import * as types from './types'
import PlansResource from '@/common/resources/Plans'

export const actions = {
	getPlans ({ commit }) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit(types.CLEAR_PLANS)
			PlansResource.getPlans().then((result) => {
				if (result.data.success) {
					result.data.plans.forEach((plan) => {
						commit(types.ADD_PLAN, plan)
					})
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant la récupération des plans'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	getPlan ({ commit }, id) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			PlansResource.getPlan(id).then((result) => {
				if (result.data.success) {
					commit(types.REPLACE_PLAN, result.data.plans[0])
					commit('LOADER_OUT')
					resolve(result.data.plans[0])
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant la récupération du plan ' + id))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Plans/actions.js